export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/es/index.js
// module id = 696
// module chunks = 9